import React from 'react';
import { Box } from '@mui/material';
import SettingsForm from '../components/Settings/SettingsForm';

const SettingsPage = () => {
  return (
    <Box>
      <SettingsForm />
    </Box>
  );
};

export default SettingsPage;
